<template>
  <div class="tutorMainContent">
    <div class="nav">
      <div class="nav_top">
        <div class="left">
          <div class="icon" @click="back">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
          <div
            v-for="item in navTitle"
            :key="item.id"
            @click="changeNav(item.id)"
          ><span v-if="item.role.indexOf(userRole)>=0" class="navTitle" :class="navIdx === item.id ? 'active': ''" >{{item.name}}</span></div>
        </div>
        <div v-if="canCoachCreateTutoRial" class="right">
        <!-- createShow.includes(userRole) -->
          <div @click="createCfaTutorial('train')">创建教案</div>
          <div @click="quickCfaTutorial('train')">快速创建教案</div>
        </div>
        <div v-if="createCfaShow.includes(userRole)" class="right">
          <div @click="createCfaTutorial('cfa')">创建SFA教案</div>
          <div @click="quickCfaTutorial('cfa')">快速创建SFA教案</div>
        </div>
      </div>
      <div v-show="navIdx !== 6 && navIdx !== 0" class="nav_bottom">
        <div v-if="navIdx === 2 || navIdx === 1 || navIdx === 3 || navIdx === 4 || navIdx === 5" class="squad_wrap">
          <div class="item_wrap">
           <span class="title">技术等级：</span>
            <div
              v-for="(item, index) in squadSortName"
              :key="index"
              class="all"
              :class="squadIdx === index ?'active':''"
                >
              <span class="item"  @click="changeQuery(true,'squadIdx',index)">{{item.nameZh}}</span>
            </div>
          </div>
          <div v-if="squadSortName.length"  class="more" @click="showSquad = true">更多<div></div></div>
        </div>
        <div v-show="navIdx !== 6 && navIdx !== 0" class="type_wrap" style="overflow: unset">
          <div class="item_wrap" >
            <span  class="title">分类：</span>
            <div
              v-for="(item, index) in tutorialType"
              :key="index"
              class="all"
              :class="{active: typeIdx === index ,notShow:index > 6}"
            >
              <div  v-if="item.list" class="listContent">
                <span class="item"  >{{item.nameZh}}</span>
                <div  class="listItem" >
                  <vue-scroll>
                    <p
                      v-for="(item_child,child_index) in item.list"
                      :key="item_child.id"
                      class="item_title"
                      @click="changeQuery(true,'typeIdx',index,item_child.id,child_index)">{{ item_child.nameZh }}</p>
                  </vue-scroll>

                </div>
              </div>
              <div v-else class="listContent">
                <span class="item" @click="changeQuery(true,'typeIdx',index,item.id)">{{item.nameZh}}</span>
              </div>
            </div>
          </div>
          <div class="more" @click="showType = true">{{$t('more')}}<div></div></div>
        </div>
        <!-- <div v-show="navIdx === 0" class="language_wrap">
          <div class="item_wrap">
            <span  class="title">语言：</span>
            <div
              v-for="(item, index) in navTlg"
              :key="index"
              class="all"
              :class="lgIdx === index ?'active':''"
            >
              <div class="listContent">
                <span class="item"  @click="changeQuery(true,'lgIdx',index)">{{item}}</span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- 点击更多全部显示 ，鼠标移出自动消失-->
        <div v-if="showSquad" class="all_squad">
          <div>技术等级：</div>
          <div class="squad_list">
            <div
              v-for="(item, index) in squadSortName"
              :key="index"
              class="squad_item"
              :class="squadIdx === index ?'active':''"
              @click="changeQuery(true,'squadIdx',index)"
            >{{item.nameZh}}</div>
          </div>
          <div class="more" @click="showSquad = false">{{$t('more')}}<div></div></div>
        </div>
        <div v-if="showType" class="all_squad" style="overflow: unset">
          <div class="item_wrap" style="flex-wrap: nowrap;align-items: baseline" >
            <div  class="title">分类：</div>
            <div style="display: flex;flex-wrap:wrap">
              <div
                v-for="(item, index) in tutorialType"
                :key="index"
                class="all"
                style="margin-bottom: 10px"
                :class="{active: typeIdx === index }"
              >
                <div  v-if="item.list" class="listContent">
                  <span class="item"  >{{item.nameZh}}</span>
                  <div  class="listItem" >
                    <vue-scroll>
                      <p
                        v-for="(item_child,child_index) in item.list"
                        :key="item_child.id"
                        class="item_title"
                        @click="changeQuery(true,'typeIdx',index,item_child.id,child_index)">{{ item_child.nameZh }}</p>
                    </vue-scroll>

                  </div>
                </div>
                <div v-else class="listContent">
                  <span class="item" @click="changeQuery(true,'typeIdx',index,item.id)">{{item.nameZh}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="more" @click="showType = false">{{$t('more')}}<div></div></div>
        </div>
      </div>
    </div>
    <div class="content" :class="(navIdx === 6 || navIdx === 0) ? 'better': ''">
      <div v-show="navIdx !== 6" class="title">
        <div class="active_wrap" v-if="navIdx !== 0">
          <div v-show="squadIdx === 0 && typeIdx === 0 && lgIdx === 0" class="all">全部</div>
          <div v-show="squadIdx !== 0" class="tag">
            {{squadSortName[squadIdx].nameZh}}
            <img
              src="@/assets/images/common/remove_icon.png"
              class="icon"
              @click="changeQuery(true,'squadIdx',0)"
            />
          </div>

          <div v-if="typeIdx !== 0" class="tag">
            <!-- {{tutorialType[typeIdx].list[type_child_index].nameZh}} -->
            <span v-if="tutorialType[typeIdx].list">{{tutorialType[typeIdx].list[type_child_index].nameZh }}</span>
            <span v-else>{{tutorialType[typeIdx].nameZh}}</span>
            <img
              src="@/assets/images/common/remove_icon.png"
              class="icon"
              @click="changeQuery(true,'typeIdx',0)"
            />
          </div>

          <div v-show="lgIdx !== 0" class="tag">
            {{navTlg[lgIdx]}}
            <img
              src="@/assets/images/common/remove_icon.png"
              class="icon"
              @click="changeQuery(true,'lgIdx',0)"
            />
          </div>

        </div>
        <div class="active_wrap" v-else></div>

        <div class="select_wrap">
          <div class="search_box">
            <input
              v-model.trim="title"
              class="yioks_input"
              type="text"
              :placeholder="$t('planNamePlaceholder')"
              @keyup.enter="changeQuery(true)">
            <div class="yioks_btn" @click="changeQuery(true)">{{$t('search')}}</div>
          </div>
        </div>
      </div>
      <div class="tutorial_list" :style="navIdx === 6 ?' margin-top:40px' :''">
        <vue-scroll v-show="dataReady">
          <div class="item_wrap">
            <div
              v-for="(item, index) in tutorialList"
              :key="index"
              class="item"
              @click="tutorialDetail(item.uuid)">
              <div class="top">
                <img :src="item.coverImgUrl" @error="item.coverImgUrl = placeHolderImg">
                <p :title="item.title">{{item.title}}</p>
              </div>
              <div class="bottom">
                <span>{{$t('author')}}：{{item.authorName}}</span><span v-if="item.authorWorkName">（{{item.authorWorkName}}）</span>
                <div>{{$t('type')}}：{{item.categoryZh}}</div>
                <div>{{$t('lastUpdateTime')}}：{{ item.updatedAt| time(true)}}</div>
              </div>
            </div>
          </div>
        </vue-scroll>
        <yioks-loading v-if="loading"></yioks-loading>
        <yioks-empty v-if="empty"></yioks-empty>
      </div>
      <Pagination :total="total" :page.sync="page" />
    </div>
  </div>
</template>

<script>

import 'vue-awesome/icons/regular/arrow-alt-circle-left'
import { time } from '@/utils/yioks_filter'
import tutorial from '@/api/tutorial'
import placeHolderImg from '@/assets/images/common/plan_default.png'
import storage from '@/utils/storage'

export default {
  name: 'Content',
  components: {
    'Pagination': () => import('@/components/Pagination')
  },
  filters: {
    time
  },
  computed: {
    canCoachCreateTutoRial() {
      const createPlan = storage.get('createPlan');
      if(this.userRole === 'coach' && createPlan === 1) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      navTitle: [{ id: 0, name: '参考教案', role: ['system', 'admin', 'youth', 'trainCamp', 'club', 'organ', 'coach', 'leader', 'player','expert'] }, { id: 1, name: '教练共享', role: ['system', 'admin','expert'] }, { id: 2, name: '教练共享', role: ['organ'] }, { id: 3, name: '教练共享', role: ['youth', 'trainCamp', 'club','coach'] },{ id: 4, name: '教练共享', role: ['leader', 'player'] }, { id: 5, name: '我的教案', role: ['coach', 'admin', 'system'] }, { id: 6, name: '收藏的教案', role: ['system', 'admin', 'youth', 'trainCamp', 'club', 'organ', 'coach', 'leader', 'player'] }],
      userRole: storage.get('userInfo').userRole,
      uid: storage.get('userInfo').uuid,
      createShow: ['coach'],
      createCfaShow: ['system', 'admin'],
      navIdx: Number(this.$route.query.idx) ? Number(this.$route.query.idx) : 0, // 顶部选中的坐标
      squadSortName: [{ nameZh: '全部' }], // 所有球队名称
      squadIdx: 0, // 选择的球队坐标
      navTlg: ['全部', '中文', '英文'],
      lgIdx: Number(this.$route.query.lgIdx) ? Number(this.$route.query.lgIdx) : 0, // 选择的语言坐标
      tutorialType: [{ nameZh: '全部' }], // 所有教案类型
      typeIdx: 0, // 选择的教案类型坐标
      showSquad: false, // 是否显示所有球队名称
      showType: false, // 是否显示所有教案类型
      total: 0,
      page: 0,
      loading: true,
      empty: false,
      dataReady: false,
      tutorialList: [],
      placeHolderImg,
      title: '',
      id: this.$route.query.id ? this.$route.query.id : '0',
      type_child_index: Number(this.$route.query.child_index) ? Number(this.$route.query.child_index) : 0
    }
  },
  watch: {
    page () {
      // if (this.navIdx !== 6) {
      //   this.getTutorial()
      // } else {
      //   this.getFavoriteList()
      // }
      this.changeQuery(false);
    },

  },
  created () {
    const { page, title, idx } = this.$route.query;
    if(page) { this.page = Number(page) } else { this.page = 0;}
    if(title) { this.title = title } else { this.title = '';}
    if(idx) this.navIdx = Number(idx) || 0;
    this.getCommon()
  },
  methods: {
    back(){
      if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    // 获取类型
    async getCommon () {
      if (this.navIdx === 1 || this.navIdx === 2 || this.navIdx === 3 || this.navIdx === 4 || this.navIdx === 5) await this.getSkill()
      try {
        const res = await tutorial.getCategory();
        let tmpList = []
        let tmpMap = {}
        let tmpPid = 0
        res.forEach(item => {
          if (item.type === 'Training') {
            if (item.nameZh.includes('：')) {
              let type = item.nameZh.split('：')[0]
              let content = item.nameZh.split('：')[item.nameZh.split('：').length - 1]
              // console.log(type, content)
              if (!tmpMap[type]) {
                tmpMap[type] = { nameZh: type, id: 0, pid: tmpPid, list: [] }
                tmpList.push(tmpMap[type])
                tmpPid++
              }
              tmpMap[type]['list'].push({ nameZh: content, id: item.id })
            } else {
              tmpList.push({ nameZh: item.nameZh, id: item.id })
            }
          }
        })
        this.tutorialType = [{ nameZh: '全部' }, ...tmpList];
        this.typeIdx = this.$route.query.typeIdx ? Number(this.$route.query.typeIdx) : 0
        // this.getTutorial()
        this.changeQuery(false)
      } catch (e) {
        console.error(e)
      }
      // tutorial.getCategory().then(res => {
      //   let tmpList = []
      //   let tmpMap = {}
      //   let tmpPid = 0
      //   res.forEach(item => {
      //     if (item.type === 'Training') {
      //       if (item.nameZh.includes('：')) {
      //         let type = item.nameZh.split('：')[0]
      //         let content = item.nameZh.split('：')[item.nameZh.split('：').length - 1]
      //         // console.log(type, content)
      //         if (!tmpMap[type]) {
      //           tmpMap[type] = { nameZh: type, id: 0, pid: tmpPid, list: [] }
      //           tmpList.push(tmpMap[type])
      //           tmpPid++
      //         }
      //         tmpMap[type]['list'].push({ nameZh: content, id: item.id })
      //       } else {
      //         tmpList.push({ nameZh: item.nameZh, id: item.id })
      //       }
      //     }
      //   })
      //   this.tutorialType = [{ nameZh: '全部' }, ...tmpList];
      //   console.log('this.tutorialType', this.tutorialType)
      //   this.typeIdx = this.$route.query.typeIdx ? Number(this.$route.query.typeIdx) : 0
      //   // this.getTutorial()
      //   this.changeQuery(false)
      // })
    },
    // 获取可查看球队的教案
    getSkill () {
      let requestName = tutorial.getCoachSkill
      return requestName().then(res => {
        this.squadSortName = [{ nameZh: '全部' }, ...res]
        this.squadIdx = this.$route.query.squadIdx ? Number(this.$route.query.squadIdx) : 0
      })
    },
    getTutorial () {
      if (this.navIdx === 6) {
        this.getFavoriteList()
        return
      }
      this.loading = true
      this.empty = false
      this.dataReady = false
      let requestName = tutorial.getYioksTutorial
      let language = ''
      let categoryId = ''
      let skillLevelId = ''
      if (this.navIdx === 1) {
        requestName = tutorial.getOfficialTutorial
      } else if (this.navIdx === 2) {
        requestName = tutorial.getOrganTutorial
      } else if (this.navIdx === 3) {
        if(this.userRole !== 'coach') {
          requestName = tutorial.getYouthTutorial
        } else {
          requestName = tutorial.getYouthTutorialByCoach
        }
      } else if (this.navIdx === 4) {
        requestName = tutorial.getSquadTutorial
      } else if (this.navIdx === 5) {
        requestName = tutorial.getMyTutorial
      }
      // 中、英文
      if (this.lgIdx === 1) {
        language = 'zh'
      } else if (this.lgIdx === 2) {
        language = 'en'
      }
      // 教案类型
      if (this.typeIdx !== 0) {
        categoryId = this.id
      }
      // 球队
      if (this.squadIdx !== 0) {
        skillLevelId = this.squadSortName[this.squadIdx].id
      }
      requestName({
        language,
        page: this.page,
        title: this.title,
        categoryId,
        skillLevelId
      }).then(res => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length > 0) {
          this.dataReady = true
          this.tutorialList = res.content
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    getFavoriteList (params) {
      this.loading = true
      this.empty = false
      this.dataReady = false
      tutorial.getFavoriteList({
        ...params
      }).then(res => {
        this.loading = false
        this.total = res.totalElements
        if (res.content.length > 0) {
          this.dataReady = true
          this.tutorialList = res.content
        } else {
          this.empty = true
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    changeNav (idx) {
      if (idx === this.navIdx) return
      this.squadIdx = this.lgIdx = this.typeIdx = 0
      this.navIdx = idx
      // 因为教练共享和我的教案接口不同，所以变化请求
      this.$router.replace({
        path: this.$route.path,
        query: { idx }
      })
      if (idx === 1 || idx === 2 || idx === 3 || idx === 4 || idx === 5) {
        this.getSkill()
      }
      this.changeQuery(true);
      // if (idx === 6) {
      //   this.getFavoriteList()
      // } else {
      //   this.getTutorial()
      // }
    },
    changeQuery(flag, type, index, id, item_index) {
      //true,'typeIdx',index,item_child.id,child_index
      const { child_index } = this.$route.query;
      if(flag) this.page = 0;

      if (item_index || item_index === 0) {
        this.type_child_index = item_index
      } else if(child_index) {
        this.type_child_index = child_index
      } else {
        this.type_child_index = 0;
      }

      if (id) {
        this.id = id
      }
      if (type && type === 'typeIdx') {
        // if (this.typeIdx === index) {
        //   return
        // } else {
          this.typeIdx = index
          this.showType = false
        // }
      }
      if (type && type === 'squadIdx') {
        if (this.squadIdx === index) {
          return
        } else {
          this.squadIdx = index
          this.showSquad = false
        }
      }
      if (type && type === 'lgIdx') {
        if (this.lgIdx === index) {
          return
        } else {
          this.lgIdx = index
        }
      }
      if(this.navIdx !== 6) {
        let obj = {}
        obj[type] = index
        obj['child_index'] = this.type_child_index
        obj['id'] = this.id
        obj['page'] = this.page
        obj['title'] = this.title
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, ...obj }
        })
        this.getTutorial()
      } else  {
        let obj = {page:this.page};
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, ...obj }
        })
        this.getFavoriteList(obj)
      }

    },
    _changeQuery (type, index, id, item_index) {
      if (item_index) {
        this.type_child_index = item_index
      } else {
        this.type_child_index = 0
      }
      if (id) {
        this.id = id
      }
      if (type === 'typeIdx') {
        this.typeIdx = index
        this.showType = false
      }
      if (type === 'squadIdx') {
        if (this.squadIdx === index) {
          return
        } else {
          this.squadIdx = index
          this.showSquad = false
        }
      }
      if (type === 'lgIdx') {
        if (this.lgIdx === index) {
          return
        } else {
          this.lgIdx = index
        }
      }
      let obj = {}
      obj[type] = index
      obj['child_index'] = this.type_child_index
      obj['id'] = this.id
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...obj }
      })
      this.getTutorial()
    },
    tutorialDetail (uuid) {
      this.$router.push({
        path: 'detail',
        query: {
          uuid,
          ...this.$route.query
        }
      })
    },
    createCfaTutorial (sessionKind) {
      window.location.href = `/static/session_editor/sspeditor.html?uid=${this.uid}&sessionKind=${sessionKind}`
    },
    quickCfaTutorial (sessionKind) {
      this.$router.push({
        path: 'quick',
        query: {
          sessionKind
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .tutorMainContent
    width 890px
    display flex
    height 710px
    justify-content space-between
    align-items center
    flex-direction column
    .nav
      color white
      background $black_color
      font-size 18px
      width 100%
      user-select none
      .nav_top
        display flex
        justify-content space-between
        padding 15px 20px
        .left,.right
          display flex
          align-items center
          .icon
            cursor pointer
            margin-right 20px
          .navTitle
            padding 10px 20px
            /*margin-right .2rem*/
            cursor pointer
            &:last-child
            &:last-child
              margin-right 0
            &.active
              background $green_color
              color #FFF
        .right
          div
            cursor pointer
            padding 10px 5px
            background $green_color
            margin-right 10px
            color #FFF
            &:last-child
              margin-right 0
      .nav_bottom
        border-top 1px solid #FFF
        margin 0 20px
        padding 15px 0
        font-size 16px
        position relative
        &>div:nth-child(2)
          margin-bottom 0
        .squad_wrap,.type_wrap,.language_wrap
          height 28px
        .squad_wrap,.type_wrap,.language_wrap,.all_squad
          display flex
          justify-content space-between
          flex-wrap wrap
          margin-bottom 15px
          overflow hidden
          .item_wrap
            display flex
            flex-wrap wrap
            align-items center
            flex 1
            .title
              width 80px
              text-align right
            .all
              padding 5px 10px
              text-align center
              margin-right 5px
              .item
                cursor pointer
              &.active
                background $green_color
                color #FFF
              .listContent
                position relative
                .item
                  cursor pointer
                .listItem
                  display none
                  position absolute
                  padding-top 5px
                  min-width 190px
                  left -10px
                  background-color $green_color
                  height 100px
                  /*overflow-y scroll*/
                  z-index 999
                  .item_title
                    margin 5px 5px 5px 0
                    padding 2px 20px 2px 10px
                    text-align left
                    white-space:nowrap;
                    cursor pointer
              &:hover
                background $green_color
                .listContent
                  .listItem
                    display block
            .notShow
              display none
          .more
            height 28px
            display flex
            cursor pointer
            align-items center
            div
              margin-left 10px
              width 12px
              height 12px
              position relative
              border 1px solid $green_color
              &::after
                content ''
                width 6px
                height 6px
                display inline-block
                border-right 1px solid $green_color
                border-bottom 1px solid $green_color
                transform rotate(45deg)
                position absolute
                left 2px
                top 1px
        .all_squad
          position absolute
          top -1px
          left -20px
          padding 15px 20px 0
          box-sizing border-box
          background #000
          width 890px
          padding-top 20px
          border-top 1px solid #FFF
          border-bottom  1px solid #FFF
          z-index 10
          .squad_list
            flex 1
            display flex
            flex-wrap wrap
            margin-top -5px
            .squad_item
              padding 5px 10px
              margin-right 12px
              margin-bottom 10px
              cursor pointer
              &.active
                background $green_color
                color #FFF
              &:hover
                background $green_color
                color #FFF
          .more
            align-items flex-start
            div
              margin-right 0
              &::after
                transform rotate(225deg)
                top 5px
    .content
      color #FFF
      font-size 18px
      background $black_color
      height 530px
      width 100%
      font-size 16px
      display flex
      flex-direction column
      &.better
        height $content_height
      .title
        display flex
        justify-content space-between
        .select_wrap
          padding: 20px 40px 20px 20px;
        .active_wrap
          padding 20px
          display flex
          .all,.tag
            padding 8px 20px
            height fit-content
            background $green_color
            margin-right 10px
          .tag
            position relative
            .icon
              width 14px
              height 14px
              position absolute
              right -7px
              top -7px
              cursor pointer
      .tutorial_list
        flex 1
        overflow hidden
        .item_wrap
          margin 0 40px
          display flex
          flex-wrap wrap
          .item
            width 395px
            padding 20px 20px 15px
            box-sizing border-box
            border 2px solid transparent
            background rgba(0, 0, 0, .35)
            cursor pointer
            margin 0 20px 20px 0
            &:nth-child(even)
              margin-right 0
            &:hover
              background rgba(0,0,0,.35) url('~@/assets/images/common/hover_yioks.png') no-repeat right center
              box-shadow inset 0 0 12px $green_color
              border-color $green_color
              background-size  117px 140px
            .top
              display flex
              border-bottom 1px solid #FFF
              margin-bottom 15px
              img
                margin-right 20px
                margin-bottom 20px
                width 170px
                height 96px
              p
                font-weight bold
                flex 1
                text-overflow ellipsis
                overflow hidden
                white-space nowrap
            .bottom
              span
                /*margin-right 40px*/
              div
               margin-top 15px
</style>
